module.exports = __webpack_public_path__ + "img/banner2.f802f2f4.png";